import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  updateProcessContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    padding: 8
  },

  updateProcessButton: {
    marginTop: 21,
    width: 112
  },

  updateProcessButtonCancel: {
    marginTop: 21,
    width: 112,
    backgroundColor: theme.palette.text.primary,
    color: theme.palette.primary.main,
    border: `2px solid ${theme.palette.primary.main}`
  },

  updateProcessInput: {
    width: '100%'
  },

  updateProcessWrapperMultiSelect: {
    width: '100%',
    '& label': {
      fontSize: theme.app.typography.label.fontSize,
      color: '#000',
      fontFamily: theme.app.typography.fontFamily.main
    }
  },

  updateProcessDate1: {
    marginRight: 16,
    width: 'calc(50% - 16px)'
  },

  updateProcessDate2: {
    width: '50%'
  },

  updateProcessDivider: {
    margin: '16px 0'
  },

  updateProcessSelectInput: {
    borderRadius: 4,
    marginBottom: 16,
    '& .MuiSelect-multiple': {
      fontFamily: theme.app.typography.fontFamily.main,
      fontSize: theme.app.typography.paragraph.fontSize,
      backgroundColor: theme.app.colors.input.background,
      border: `1px solid ${theme.app.colors.input.background}`,
      color: '#000',
      '&:focus': {
        outline: 'none'
      },
      '&:disabled': {
        opacity: 0.5
      },
      '&:hover': {
        color: theme.app.colors.text.primary,
        backgroundColor: theme.palette.secondary.main
      }
    }
  },

  updateProcessButtonContainer: {
    display: 'flex',
    marginLeft: 'auto',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& button': {
      margin: '0 0 0 16px'
    }
  },

  holeProcessMenuItem: {
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
      color: theme.palette.primary.main
    },
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate': {
      color: theme.palette.primary.main
    },
    '& .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.main
    }
  },

  updateProcessLoading: {
    background: 'rgb(255 255 255 / 70%)'
  },

  updateProcessMenuItem: {
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.Mui-checked': {
      color: theme.palette.primary.main
    },
    '& .css-12wnr2w-MuiButtonBase-root-MuiCheckbox-root.MuiCheckbox-indeterminate': {
      color: theme.palette.primary.main
    },
    '& .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root.Mui-selected:hover': {
      backgroundColor: theme.palette.primary.main
    }
  }
}))
